import dynamic from 'next/dynamic';

const DynamicDevContainer = dynamic(() => import('./dev-widget'));

// TODO: [T1-9377] We can possible make page sections Dynamic and only request/render if they are on the page configs
// eslint-disable-next-line import/prefer-default-export
export { DynamicDevContainer };
